import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
export function LoadingPage() {
  const navigate = useNavigate();
  const [progress, setProgress] = useState(0);
  useEffect(() => {
    const interval = setInterval(() => {
      setProgress(prev => {
        if (prev >= 100) {
          clearInterval(interval);
          return 100;
        }
        // Accelerate toward the end
        const increment = prev < 60 ? 3 : prev < 85 ? 5 : 8;
        return Math.min(prev + increment, 100);
      });
    }, 80);
    return () => clearInterval(interval);
  }, []);
  useEffect(() => {
    if (progress === 100) {
      const timeout = setTimeout(() => navigate('/dashboard'), 400);
      return () => clearTimeout(timeout);
    }
  }, [progress, navigate]);
  return <div className="min-h-screen bg-catalyst-black flex flex-col justify-center items-center relative overflow-hidden font-body" data-id="element-577">
      {/* Background gradients */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none" data-id="element-578">
        <div className="absolute -top-[30%] -right-[15%] w-[60%] h-[60%] rounded-full bg-catalyst-brown-dark/20 blur-[120px]" data-id="element-579"></div>
        <div className="absolute -bottom-[30%] -left-[15%] w-[50%] h-[50%] rounded-full bg-catalyst-brown-dark/15 blur-[120px]" data-id="element-580"></div>
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[40%] h-[40%] rounded-full bg-catalyst-mustard/5 blur-[100px]" data-id="element-581"></div>
      </div>

      <div className="z-10 flex flex-col items-center text-center px-6" data-id="element-582">
        {/* Pulsing logo */}
        <div className="mb-10" style={{
        animation: 'pulse-glow 2s ease-in-out infinite'
      }} data-id="element-583">
          <img src="https://cdn.magicpatterns.com/uploads/fhU3kGRUAmhJPAYevpphn9/header-logo.png" alt="Black Opportunity Fund" className="h-16 mx-auto filter brightness-0 invert" data-id="element-584" />
        </div>

        {/* Loading text */}
        <h2 className="text-xl font-heading font-semibold text-white mb-2" data-id="element-585">
          BOF Catalyst
        </h2>
        <p className="text-sm text-gray-400 mb-10" data-id="element-586">Preparing your workspace…</p>

        {/* Progress bar */}
        <div className="w-64 h-1.5 bg-white/10 rounded-full overflow-hidden" data-id="element-587">
          <div className="h-full bg-catalyst-mustard rounded-full transition-all duration-150 ease-out" style={{
          width: `${progress}%`
        }} data-id="element-588"></div>
        </div>

        <p className="text-xs text-gray-600 mt-4 tabular-nums" data-id="element-589">{progress}%</p>
      </div>

      {/* Keyframe for logo pulse */}
      <style data-id="element-590">{`
        @keyframes pulse-glow {
          0%, 100% { opacity: 1; transform: scale(1); }
          50% { opacity: 0.7; transform: scale(1.03); }
        }
      `}</style>
    </div>;
}